import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m8 3 4 8 5-5 5 15H2L8 3z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "MountainSnow";
const MountainSnow = memo(themed(Icon));
export {
  MountainSnow
};
//# sourceMappingURL=mountain-snow.js.map
